// libs
import React from 'react';
import { Outlet } from 'react-router-dom';
const CampaignDetails = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Outlet, null)));
};
export default CampaignDetails;
